import { createFileRoute, redirect } from '@tanstack/react-router'

// The Payroll page is retired: its one real control, the Xero card, was removed
// rather than moved (owner decision, 25 Oct 2026). This stays as a redirect for
// bookmarks and old links. It checks nothing itself, and the Pay Runs tab has no
// client-side gate either: the API gates pay-run data on `payroll.view`.
export const Route = createFileRoute('/_authenticated/_organization/payroll/')({
  beforeLoad: () => {
    throw redirect({
      to: '/timesheets',
      search: { tab: 'payruns' },
      replace: true,
    })
  },
})
